import { actions } from "@app/utils";
import { createApiClient } from "@app/utils/apiClient";

export const footageClient = createApiClient(
  actions["exd-storyteller-ai/footage"],
);

export const getFootage = async (filters = {}, options = {}) => {
  const response = await footageClient.get("/", filters, options);

  if (!response.ok) {
    throw new Error("Failed to fetch footage", { cause: response });
  }

  return {
    footage: response.data?.footage ?? [],
    pagination: response.data?.pagination ?? {},
  };
};

export const getFootageIndustries = async (options = {}) => {
  const response = await footageClient.get("/industries", {}, options);

  if (!response.ok) {
    throw new Error("Failed to fetch footage industries", { cause: response });
  }

  return response.data?.industries ?? [];
};

export const updateFootage = async (id, footageData, options = {}) => {
  if (!id) {
    throw new Error("Footage ID is required to update footage");
  }

  const response = await footageClient.patch(`/${id}`, footageData, options);

  if (!response.ok) {
    throw new Error("Failed to update footage", { cause: response });
  }

  return response.data?.footage;
};
